/* eslint-disable max-lines */

import { animated } from '@react-spring/web'
import styled from 'styled-components'

import { breakpoints } from 'components/designSystem/shared/breakpoints'
import { ContainerDesktopHeight } from 'components/designSystem/shared/containerDesktopHeight'

export const CLIP_PATH_MOBILE = {
  outer: `
    clip-path: polygon(
      23.397% 98.131%,
      11.983% 98.131%,
      11.983% 98.131%,
      10.53% 98.096%,
      9.199% 97.997%,
      7.983% 97.838%,
      6.878% 97.623%,
      5.879% 97.358%,
      4.98% 97.048%,
      4.177% 96.698%,
      3.464% 96.313%,
      2.837% 95.897%,
      2.29% 95.455%,
      2.29% 95.455%,
      1.816% 94.991%,
      1.413% 94.511%,
      1.076% 94.02%,
      0.799% 93.522%,
      0.578% 93.023%,
      0.408% 92.527%,
      0.285% 92.04%,
      0.203% 91.566%,
      0.157% 91.111%,
      0.143% 90.679%,
      0.143% 6.275%,
      0.143% 6.275%,
      0.29% 5.27%,
      0.717% 4.317%,
      1.401% 3.428%,
      2.317% 2.616%,
      3.443% 1.893%,
      4.757% 1.274%,
      6.233% 0.77%,
      7.85% 0.394%,
      9.584% 0.16%,
      11.412% 0.078%,
      88.73% 0.078%,
      88.73% 0.078%,
      90.558% 0.16%,
      92.292% 0.394%,
      93.909% 0.77%,
      95.386% 1.274%,
      96.699% 1.893%,
      97.826% 2.616%,
      98.742% 3.428%,
      99.425% 4.317%,
      99.852% 5.27%,
      100% 6.275%,
      100% 94.13%,
      100% 94.13%,
      99.869% 95.086%,
      99.483% 96.003%,
      98.854% 96.866%,
      97.991% 97.659%,
      96.906% 98.363%,
      95.609% 98.964%,
      94.112% 99.445%,
      92.424% 99.788%,
      90.558% 99.979%,
      88.523% 100%,
      88.523% 100%,
      87.397% 99.962%,
      86.163% 99.918%,
      84.856% 99.871%,
      83.514% 99.82%,
      82.173% 99.769%,
      80.869% 99.717%,
      79.639% 99.667%,
      78.52% 99.621%,
      77.548% 99.579%,
      76.76% 99.543%,
      76.76% 99.543%,
      71.429% 99.301%,
      66.099% 99.082%,
      60.769% 98.885%,
      55.437% 98.711%,
      50.104% 98.559%,
      44.769% 98.429%,
      39.431% 98.321%,
      34.09% 98.236%,
      28.745% 98.172%,
      23.397% 98.131%
    );
  `,
  inner: `
    clip-path: polygon(
      11.396% 0%,
      11.396% 0%,
      9.548% 0.082%,
      7.794% 0.32%,
      6.159% 0.7%,
      4.666% 1.21%,
      3.338% 1.837%,
      2.199% 2.567%,
      1.272% 3.389%,
      0.581% 4.288%,
      0.149% 5.253%,
      0% 6.27%,
      0% 90.608%,
      0% 90.608%,
      0.06% 91.5%,
      0.267% 92.467%,
      0.661% 93.47%,
      1.28% 94.468%,
      2.165% 95.422%,
      3.356% 96.291%,
      4.892% 97.037%,
      6.812% 97.619%,
      9.157% 97.997%,
      11.966% 98.132%,
      23.362% 98.132%,
      23.362% 98.132%,
      28.702% 98.174%,
      34.038% 98.237%,
      39.37% 98.323%,
      44.699% 98.43%,
      50.026% 98.56%,
      55.35% 98.712%,
      60.673% 98.886%,
      65.995% 99.082%,
      71.316% 99.301%,
      76.638% 99.543%,
      76.638% 99.543%,
      77.426% 99.579%,
      78.397% 99.621%,
      79.515% 99.668%,
      80.743% 99.717%,
      82.045% 99.769%,
      83.385% 99.82%,
      84.726% 99.871%,
      86.031% 99.919%,
      87.264% 99.962%,
      88.388% 100%,
      88.388% 100%,
      90.446% 99.979%,
      92.334% 99.785%,
      94.042% 99.437%,
      95.557% 98.95%,
      96.869% 98.342%,
      97.967% 97.628%,
      98.84% 96.826%,
      99.477% 95.952%,
      99.867% 95.024%,
      100% 94.056%,
      100% 6.27%,
      100% 6.27%,
      99.851% 5.253%,
      99.419% 4.288%,
      98.728% 3.389%,
      97.801% 2.567%,
      96.662% 1.837%,
      95.334% 1.21%,
      93.841% 0.7%,
      92.206% 0.32%,
      90.452% 0.082%,
      88.604% 0%,
      11.396% 0%
    );    
  `,
}

export const CLIP_PATH_DESKTOP = {
  outer: `
    clip-path: polygon(
      0.053% 4.033%,
      0.053% 4.033%,
      0.096% 3.389%,
      0.222% 2.778%,
      0.424% 2.208%,
      0.694% 1.688%,
      1.027% 1.226%,
      1.414% 0.829%,
      1.849% 0.506%,
      2.326% 0.265%,
      2.838% 0.115%,
      3.377% 0.063%,
      96.675% 0.063%,
      96.675% 0.063%,
      97.215% 0.115%,
      97.726% 0.265%,
      98.203% 0.506%,
      98.639% 0.829%,
      99.026% 1.226%,
      99.359% 1.688%,
      99.629% 2.208%,
      99.831% 2.778%,
      99.956% 3.389%,
      100% 4.033%,
      100% 93.006%,
      100% 93.006%,
      99.974% 93.716%,
      99.898% 94.386%,
      99.776% 95.015%,
      99.612% 95.604%,
      99.409% 96.154%,
      99.17% 96.665%,
      98.9% 97.137%,
      98.601% 97.571%,
      98.279% 97.968%,
      97.935% 98.329%,
      97.935% 98.329%,
      97.574% 98.653%,
      97.199% 98.94%,
      96.814% 99.193%,
      96.422% 99.41%,
      96.028% 99.592%,
      95.635% 99.74%,
      95.246% 99.855%,
      94.865% 99.936%,
      94.496% 99.984%,
      94.142% 100%,
      91.398% 100%,
      91.398% 100%,
      90.181% 99.995%,
      88.916% 99.979%,
      87.603% 99.955%,
      86.238% 99.922%,
      84.817% 99.881%,
      83.339% 99.833%,
      81.801% 99.78%,
      80.2% 99.721%,
      78.532% 99.658%,
      76.795% 99.591%,
      76.795% 99.591%,
      75.104% 99.526%,
      73.347% 99.459%,
      71.523% 99.391%,
      69.628% 99.323%,
      67.662% 99.254%,
      65.621% 99.187%,
      63.503% 99.122%,
      61.307% 99.058%,
      59.028% 98.998%,
      56.666% 98.941%,
      56.666% 98.941%,
      51.863% 98.836%,
      47.058% 98.741%,
      42.252% 98.655%,
      37.446% 98.58%,
      32.64% 98.515%,
      27.836% 98.461%,
      23.035% 98.418%,
      18.237% 98.387%,
      13.443% 98.368%,
      8.654% 98.362%,
      8.654% 98.362%,
      7.935% 98.354%,
      7.234% 98.328%,
      6.553% 98.279%,
      5.896% 98.203%,
      5.263% 98.095%,
      4.656% 97.952%,
      4.078% 97.769%,
      3.531% 97.541%,
      3.016% 97.264%,
      2.535% 96.934%,
      2.535% 96.934%,
      2.092% 96.548%,
      1.687% 96.1%,
      1.321% 95.585%,
      0.998% 94.999%,
      0.718% 94.337%,
      0.484% 93.594%,
      0.299% 92.767%,
      0.163% 91.85%,
      0.081% 90.839%,
      0.053% 89.729%,
      0.053% 4.033%
    );
  `,
  inner: `
    clip-path: polygon(
      3.383% 0%,
      3.383% 0%,
      2.834% 0.053%,
      2.313% 0.206%,
      1.828% 0.451%,
      1.385% 0.78%,
      0.991% 1.183%,
      0.653% 1.654%,
      0.378% 2.184%,
      0.172% 2.763%,
      0.044% 3.385%,
      0% 4.04%,
      0% 89.673%,
      0% 89.673%,
      0.111% 91.801%,
      0.434% 93.555%,
      0.951% 94.97%,
      1.647% 96.082%,
      2.505% 96.926%,
      3.509% 97.538%,
      4.642% 97.952%,
      5.887% 98.204%,
      7.228% 98.329%,
      8.65% 98.363%,
      8.65% 98.363%,
      13.436% 98.369%,
      18.227% 98.388%,
      23.022% 98.419%,
      27.821% 98.462%,
      32.622% 98.516%,
      37.425% 98.58%,
      42.229% 98.656%,
      47.033% 98.742%,
      51.835% 98.837%,
      56.636% 98.942%,
      56.636% 98.942%,
      58.996% 98.999%,
      61.273% 99.059%,
      63.468% 99.122%,
      65.585% 99.188%,
      67.625% 99.255%,
      69.59% 99.323%,
      71.483% 99.391%,
      73.306% 99.459%,
      75.062% 99.526%,
      76.753% 99.591%,
      76.753% 99.591%,
      78.489% 99.658%,
      80.156% 99.721%,
      81.756% 99.78%,
      83.294% 99.833%,
      84.771% 99.881%,
      86.191% 99.922%,
      87.556% 99.955%,
      88.869% 99.979%,
      90.133% 99.995%,
      91.35% 100%,
      94.093% 100%,
      94.093% 100%,
      94.822% 99.935%,
      95.598% 99.738%,
      96.392% 99.405%,
      97.175% 98.932%,
      97.917% 98.315%,
      98.589% 97.552%,
      99.163% 96.637%,
      99.608% 95.567%,
      99.897% 94.338%,
      100% 92.947%,
      100% 4.04%,
      100% 4.04%,
      99.956% 3.385%,
      99.828% 2.763%,
      99.622% 2.184%,
      99.347% 1.654%,
      99.009% 1.183%,
      98.615% 0.78%,
      98.172% 0.451%,
      97.687% 0.206%,
      97.166% 0.053%,
      96.617% 0%,
      3.383% 0%
    );
  `,
}

export const ClipPathOuter = styled(animated.div)`
  display: flex;
  box-sizing: border-box;
  padding: 0;
  position: relative;
  justify-content: center;
  align-items: center;
  ${CLIP_PATH_DESKTOP.outer};
  background-color: var(--border-soft);
  max-height: ${ContainerDesktopHeight.largeDesktop}px;

  @media screen and (max-width: ${breakpoints.mobile}px) {
    overflow: hidden;
    flex-direction: column;
    height: 100%;
    ${CLIP_PATH_MOBILE.outer};
  }
`

export const ClipPathInner = styled(animated.div)`
  ${CLIP_PATH_DESKTOP.inner};
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  box-sizing: border-box;

  @media screen and (max-width: ${breakpoints.mobile}px) {
    ${CLIP_PATH_MOBILE.inner};
    overflow: hidden;
    position: relative;
  }
`
